var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('UiAlert',{attrs:{"dismissible":false,"type":"error"}},[_vm._v("\n  "+_vm._s(_vm.$tr('rendererNotAvailable'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }